// extracted by mini-css-extract-plugin
module.exports =  {"table":"WxJbSO8B247a9rpY3B5o","alert":"Cw93Twhv8muTZWrdb1gP"};